import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as constants from '../constants/system-setup-constants';

import type {List, MapOf} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type SsAnnotationsStore = {
    annotationIcons: List<
        MapOf<{
            annotationIconId?: string | null;
            color: string;
            name?: string;
        }>
    >;
    annotationsIconsLoaded: boolean;
    annotationGroups: List<
        MapOf<{
            annotationGroupId: string;
            sort?: number;
            inUse?: boolean;
            name: string;
        }>
    >;
    annotationsGroupsLoaded: boolean;
};

const initialState = (): SsAnnotationsStore => {
    return {
        annotationIcons: Immutable.List(),
        annotationsIconsLoaded: false,
        annotationGroups: Immutable.List(),
        annotationsGroupsLoaded: false,
    };
};

const actionsMap: ActionsMap<SsAnnotationsStore> = {
    [constants.ANNOTATIONS_GROUPS_SUCCESS]: (state, action) => {
        return {
            annotationGroups: action.data,
            annotationsGroupsLoaded: true,
        };
    },
    [constants.ANNOTATIONS_ICONS_SUCCESS]: (state, action) => {
        return {
            annotationIcons: action.data,
            annotationsIconsLoaded: true,
        };
    },
    [constants.DISPOSE_SS_ANNOTATIONS_STORE]: () => {
        return initialState();
    },
};

export default createReducer<SsAnnotationsStore>(initialState(), actionsMap);
